export const noEndBeforeStart = {
    name: 'No end date before start date.',
    validate: (frequency: any) => {
        if (frequency.startOn && frequency.endOn) {
            return frequency.endOn > frequency.startOn;
        }
        return true;
    },
};
